
const MeetOurTeamClan = [
    {
        id: 1,
        clanImageFront: require('../../Assets/Our_Team/Colleague-Pics/Renu-S.jpeg'),
        clanImageBack: require('../../Assets/Our_Team/Childhood-Pics/Renu.png'),
        clanHeading: "Renu S",
        clanParaFront: "Operation Head",
        clanParaBack: "Wanted to be an Interior Designer"
    },
    {
        id: 2,
        clanImageFront: require('../../Assets/Our_Team/Colleague-Pics/Punith-R.jpeg'),
        clanImageBack: require('../../Assets/Our_Team/Childhood-Pics/Punith.png'),
        clanHeading: "Punith R A",
        clanParaFront: "Team Lead",
        clanParaBack: "Wanted to be an Aerospace Engineer"
    },
    {
        id: 3,
        clanImageFront: require('../../Assets/Our_Team/Colleague-Pics/Shailaja-B.webp'),
        clanImageBack: require('../../Assets/Our_Team/Childhood-Pics/Shailaja.webp'),
        clanHeading: "Shailaja B",
        clanParaFront: "Digital Marketing Executive",
        clanParaBack: "Wanted to be a Doctor"
    },
    {
        id: 4,
        clanImageFront: require('../../Assets/Our_Team/Colleague-Pics/Swarnali-B.webp'),
        clanImageBack: require('../../Assets/Our_Team/Childhood-Pics/Swarnali.webp'),
        clanHeading: "Swarnali B",
        clanParaFront: "Content Writer",
        clanParaBack: "Wanted to be an Athlete"
    },
    // {
    //     id: 5,
    //     clanImageFront: require('../../Assets/Our_Team/Colleague-Pics/Aishik-RC.webp'),
    //     clanImageBack: require('../../Assets/Our_Team/Childhood-Pics/Aishik.webp'),
    //     clanHeading: "Aishik RC",
    //     clanParaFront: "Content Writer",
    //     clanParaBack: "Wanted to be a Merchant Banker"
    // },
];

export default MeetOurTeamClan;